'use client';

import { Config, Stage } from '@3fourteen/core';
import { downloadFile } from 'helpers/downloadFile';
import { useCustomResearch } from 'hooks/useCustomResearch';
import parse, { attributesToProps, domToReact, Element } from 'html-react-parser';
import { useMemo } from 'react';

import { LoadingDots } from 'components/LoadingDots';
import Link from 'next/link';
import { IS_PRODUCTION } from 'services/environment';

const CustomResearchHtml = ({ filename }) => {
  const { data, isLoading } = useCustomResearch(filename);

  const options = useMemo(() => {
    if (data) {
      return {
        replace: (domNode) => {
          const { attribs } = domNode;

          if (!(domNode instanceof Element) || !attribs?.href) return;

          if (attribs.href.includes('/custom-research/')) {
            // Get everything after '/custom-research/'
            const fullPath = attribs.href.split('/custom-research/')[1];
            const fileWithoutParams = fullPath.split('?')[0];
            const fileExtension = fileWithoutParams.split('.').pop();
            const fileWithoutExtension = fileWithoutParams.substring(
              0,
              fileWithoutParams.lastIndexOf('.')
            );
            const props = attributesToProps(attribs);

            if (fileExtension === 'csv') {
              return (
                <a
                  {...props}
                  href='#'
                  onClick={async (e) => {
                    e.preventDefault();
                    const stage = IS_PRODUCTION ? Stage.prod : Stage.dev;
                    const url = `${Config[stage].apiUrl}/custom-research/${fileWithoutParams}`;

                    await downloadFile(url, fileWithoutParams, {
                      method: 'GET',
                      credentials: 'include',
                      headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'text/plain',
                      },
                    });
                  }}>
                  {domToReact(domNode.children)}
                </a>
              );
            }

            return (
              <Link
                as={`/custom-research/${fullPath}`}
                href={`/custom-research/${fileWithoutExtension}`}
                style={props.style}
                className={props.className}>
                {domToReact(domNode.children)}
              </Link>
            );
          }
        },
      };
    } else {
      return {};
    }
  }, [data]);

  if (isLoading) {
    return (
      <div className='flex h-full items-center justify-center'>
        <LoadingDots color='#999' size='regular' />
      </div>
    );
  }

  if (!data) {
    return (
      <div className='flex items-center justify-center'>
        <p>Unable to load this HTML file</p>
      </div>
    );
  }

  return <div className='min-h-screen '>{parse(data, options)}</div>;
};

export default CustomResearchHtml;
